export enum WritingEnum {
  ORIGINAL = 'ORIGINAL',
  FAN_FICTION = 'FAN_FICTION',
}
